import { Channel, ChannelService } from '../../channel';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyService } from '@app/_components/property';

@Component({
    selector: 'app-channel',
    templateUrl: './channel.component.html',
    styleUrls: ['./channel.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ChannelComponent implements OnInit {
    channelSourceIds: any;

	constructor(
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private channelService: ChannelService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.channel = data.channel,
			this.statuses = channelService.statuses;
			this.channelSourceIds = channelService.channelSourceIds;
	}

	@Input() channel: Channel;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	channelId: number;
	properties: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'shortTermRentalId': [{ type: 'required', message: 'Required' }],
		'propertyCode': [],
		'channelProviderId': [{ type: 'required', message: 'Required' }],
		'channelId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [{ type: 'required', message: 'Required' }],
		'propertyName': [],
		'channelPropId': [],
		'publishCalendar': [],
		'publishAddress': [],
		'acceptBookingsOnline': [],
		'rateAdjustmentPercent': [],
		'rateAdjustmentAmount': [],
		'flatFeeAdjustmentAmount': [],
		'dailyFeeAdjustmentAmount': [],
		'channelListingStatus': [],
		'channelRateStatus': [],
		'channelAvailStatus': [],
		'channelContentStatus': [],
		'syncEnabled': [],
	};
	
	ngOnInit() {
		this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole channel object
		if (this.channel) {
			this.channelId = this.channel.channelId;
			this.fixDates();
			this.form1.patchValue(this.channel);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.channelId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.channelService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.channel = res.data.channel;
						this.doAdd.emit(this.channel);
					},
					(err: any) => {
						console.log('channel-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('channel: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.channelService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.channel = res.data.channel;
						this.doUpdate.emit(this.channel);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.channelService.delete(this.channel.channelId)
				.subscribe(
					(res: any) => {
						console.log('channel-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.channel);
					},
					(err: any) => {
						console.log('channel-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			shortTermRentalId:  ['', Validators.required],
			propertyCode: [],
			channelProviderId: ['', Validators.required],
			channelId: [this.channelId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			status: ['', Validators.required],
			propertyName: [],
			channelPropId: [],
			publishCalendar: [true],
			publishAddress: [true],
			acceptBookingsOnline: [true],
			rateAdjustmentPercent: [],
			rateAdjustmentAmount: [],
			flatFeeAdjustmentAmount: [],
			dailyFeeAdjustmentAmount: [],
			channelListingStatus: [],
			channelRateStatus: [],
			channelAvailStatus: [],
			channelContentStatus: [],
			syncEnabled: [true],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.channel.channelDate = moment(this.channel.channelDate).toDate();
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}
}
